<template>
    <div>
        <base-table
            v-if="isRendered"
            :table-data="sessions"
            :config="sessionTableConfig"
            v-on:responses="showSessionResponses($event)"
            v-on:download="downloadSummary($event)"
            empty-message="This link doesn't have any activity yet."
            :rows-per-page="20"
        ></base-table>
        <!-- Response Modal -->
        <base-modal id="response-modal" :loading="modalLoading" size="large">
            <template slot="title">
                <p class="mb-1">Session Results Summary</p>
                <p v-show="selectedSession.id" class="text-secondary medium mb-0">
                    Session ID: {{ selectedSession.id }}
                </p>
            </template>
            <template>
                <div class="row">
                    <div class="col-12">
                        <learner-results-summary
                            v-if="selectedSession.results"
                            :results="selectedSession.results"
                            :display-timestamps="true"
                            :show-chat-logs="true"
                            :show-notes="true"
                        ></learner-results-summary>
                    </div>
                </div>
            </template>
            <template slot="footer">
                <button class="btn btn-secondary" type="button" data-dismiss="modal">Close</button>
            </template>
        </base-modal>
    </div>
</template>

<script>
import Utilities from "@/assets/js/utilities.js"
import BaseTable from "@/components/BaseTable"
import BaseModal from "@/components/BaseModal"
import LearnerResultsSummary from "@/components/LearnerResultsSummary"
import http from "@/axios.js"

export default {
    name: "SessionListReport",
    components: {
        BaseTable,
        BaseModal,
        LearnerResultsSummary,
    },
    props: {
        libraryItemId: {
            type: String,
            required: false,
        },
        organizationId: {
            type: Number,
            required: false,
        },
        startDate: {
            type: String,
            required: false,
            default: null,
        },
        endDate: {
            type: String,
            required: false,
            default: null,
        },
        shareLinkId: {
            type: Number,
            required: false,
            default: null,
        },
        includeShareLinks: {
            type: Boolean,
            required: false,
            default: true,
        },
        pageId: {
            type: Number,
            required: false,
            default: null,
        },
    },
    data() {
        return {
            sessionTableConfig,
            selectedSession: {
                id: null,
                results: null,
            },
            modalLoading: false,
            sessions: [],
            isRendered: false,
        }
    },
    methods: {
        refresh() {
            let query = {
                libraryItemId: this.libraryItemId,
                organizationId: this.organizationId,
                startDate: this.startDate,
                endDate: this.endDate,
                shareLinkId: this.shareLinkId,
                includeShareLinks: this.includeShareLinks,
                pageId: this.pageId,
            }
            this.$store.dispatch("addLoad")
            let vm = this
            http.get("/api/reports/link-sessions/", {
                params: query
            })
                .then(function (response) {
                    vm.sessions = response.data
                    vm.isRendered = true
                })
                .finally(function () {
                    vm.$store.dispatch("removeLoad")
                })
        },
        // Open the session response modal.
        showSessionResponses(session) {
            $("#response-modal").modal("show")
            this.loadSession(session)
        },
        // Load details for a given session.
        loadSession(session) {
            if (session.id === this.selectedSession.id) {
                return
            }
            this.selectedSession = {
                activities: [],
                results: {
                    responses: [],
                    timers: [],
                },
            }
            this.selectedSession.activities = []
            this.modalLoading = true
            let vm = this
            http.get(`/api/reports/link-sessions/${session.id}/`).then(function (response) {
                vm.selectedSession = response.data
                vm.modalLoading = false
            })
        },
        // Export a response summary as a PDF.
        downloadSummary(session) {
            window.open(`/export/sessions/${session.id}/response-summary`, "_blank")
        },
    },
}

const sessionTableConfig = {
    initialSort: "Started On",
    initialSortDescend: true,
    multiSelect: false,
    actions: true,
    customActions: [
        {
            name: "Results",
            event: "responses",
        },
        {
            name: "Export Summary",
            event: "download",
        },
    ],
    columns: [
        {
            name: "Learner",
            sort: true,
            display: (row) => {
                return row.learner_identifier || "[Anonymous Learner]"
            },
            badges: (row) => {
                if (row.learner_is_link_user) {
                    return ["Share Link Learner"]
                }
            },
        },
        {
            name: "Complete",
            sort: true,
            key: "complete",
            display: (row) => {
                return row.complete ? "Yes" : "No"
            },
        },
        {
            name: "Successful",
            sort: true,
            key: "successful",
            display: (row) => {
                return row.successful ? "Yes" : "No"
            },
        },
        {
            name: "Score",
            sort: true,
            key: "score",
            display: (row) => {
                if (row.score && row.score_max) {
                    return row.score + " / " + row.score_max
                } else if (row.score !== null) {
                    return String(row.score)
                } else {
                    return "-"
                }
            },
        },
        {
            name: "Last Screen Visited",
            sort: true,
            key: "current_node",
            display: (row) => {
                if (!row.current_node) {
                    return "(none)"
                }
                return `${row.current_node.number}. ${Utilities.trimString(row.current_node.title, 26)}`
            },
            classes: "badge badge-gray",
        },
        {
            name: "Started On",
            sort: true,
            type: "date",
            sortKey: "start_time",
            display: (row) => {
                return Utilities.formatDateTime(row.start_time)
            },
        },
    ],
}
</script>

<style>
</style>